import { useEffect } from 'react'

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmStyle = 'danger'
}) {
  useEffect(() => {
    if (!isOpen) return

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    const handleEnter = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        onConfirm()
      }
    }

    document.addEventListener('keydown', handleEscape)
    document.addEventListener('keydown', handleEnter)

    const previousActiveElement = document.activeElement
    const confirmButton = document.querySelector('[data-confirm-button]')
    if (confirmButton) {
      confirmButton.focus()
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.removeEventListener('keydown', handleEnter)
      if (previousActiveElement) {
        previousActiveElement.focus()
      }
    }
  }, [isOpen, onClose, onConfirm])

  if (!isOpen) return null

  const getConfirmButtonStyle = () => {
    if (confirmStyle === 'danger') {
      return {
        background: 'linear-gradient(135deg, #FF6B6B 0%, #C92A2A 100%)',
        border: '2px solid rgba(255, 107, 107, 0.6)',
        boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4), 0 0 20px rgba(255, 107, 107, 0.3)'
      }
    }
    return {}
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
        animation: 'fadeIn 0.2s ease'
      }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div
        className="card"
        style={{
          maxWidth: '450px',
          width: '100%',
          margin: 0,
          background: 'linear-gradient(135deg, rgba(34, 139, 34, 0.95) 0%, rgba(0, 100, 0, 0.98) 100%)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '2px solid rgba(152, 251, 152, 0.6)',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5), 0 0 60px rgba(152, 251, 152, 0.4)',
          animation: 'slideIn 0.3s ease'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          id="modal-title"
          style={{
            fontSize: '22px',
            marginBottom: '16px',
            color: '#98FB98',
            textShadow: '0 0 15px rgba(152, 251, 152, 0.8)',
            fontWeight: '700'
          }}
        >
          {title}
        </h3>
        <p
          id="modal-description"
          style={{
            fontSize: '15px',
            color: 'rgba(152, 251, 152, 0.95)',
            lineHeight: '1.6',
            marginBottom: '28px',
            textShadow: '0 0 8px rgba(152, 251, 152, 0.5)'
          }}
        >
          {message}
        </p>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button
            onClick={onClose}
            className="btn-secondary"
            style={{ flex: '1 1 120px', minHeight: '44px' }}
            aria-label={cancelText}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="btn"
            data-confirm-button
            style={{
              flex: '1 1 120px',
              minHeight: '44px',
              ...getConfirmButtonStyle()
            }}
            aria-label={confirmText}
          >
            {confirmText}
          </button>
        </div>
        <div style={{
          marginTop: '16px',
          fontSize: '12px',
          color: 'rgba(152, 251, 152, 0.7)',
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          Press ESC to cancel, ENTER to confirm
        </div>
      </div>
    </div>
  )
}
